<template>
    <b-modal :id="modalId ? modalId : 'upload-media-modal'" title="Upload Media" hide-footer>
        <!-- Upload media -->
        <div class="upload-media">
            <el-upload
                    :http-request="uploadFile"
                    class="upload-demo"
                    drag
                    :action="ticketMediaUrl"
                    :file-list="fileList"
                    multiple>
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">Drop file here or <em>click to upload</em></div>
<!--                <div class="el-upload__tip" slot="tip">jpg/png files with a size less than 500kb</div>-->
            </el-upload>
        </div>
        <!-- / Upload media -->

    </b-modal>
</template>

<script>
    import axios from "axios";
    import Forms from "../../../../../mixins/Forms";
    import {mapGetters} from "vuex";

    export default {
        name: "UploadMediaModal",
        props: ['ticketId', 'modalId'],
        data() {
            return {
                fileList: []
            }
        },
        mixins: [Forms],
        methods: {
            uploadFile(params) {
                let vm = this;

                const fileData = new FormData()
                fileData.append('file', params.file)

                const config = {
                    headers: {
                        'Content-Type': `multipart/form-data; boundary=${fileData._boundary}`,
                    },
                    onUploadProgress: progressEvent => {
                        const percentCompleted = Math.floor((progressEvent.loaded * 100) / progressEvent.total)
                        params.onProgress({ percent: percentCompleted })
                    }
                }

                axios.post(this.ticketMediaUrl, fileData, config).then(r => {
                    params.onSuccess(r);
                    vm.$emit('file-uploaded', r.data);
                }).catch(e => {
                    params.onError(e);
                });
            }
        },
        computed: {
            ...mapGetters('ticketViewer', {
                ticket: 'ticket'
            }),

            ticketMediaUrl() {
                return API_BASE + '/tickets/' + this.ticketId + '/media';
            }
        }
    }
</script>

<style lang="scss">
    .upload-media {
        text-align: center;


        .avatar-uploader .el-upload {
            border: 1px dashed #d9d9d9;
            border-radius: 6px;
            cursor: pointer;
            position: relative;
            overflow: hidden;
        }

        .avatar-uploader .el-upload:hover {
            border-color: #409EFF;
        }

        .avatar-uploader-icon {
            font-size: 28px;
            color: #8c939d;
            width: 178px;
            height: 178px;
            line-height: 178px;
            text-align: center;
        }

        .avatar {
            width: 178px;
            height: 178px;
            display: block;
        }
    }
</style>
